import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';

import { DEAL_STAGE, Lead } from '@tassomutuo-backoffice/types';
import useDateFormat from '../../../hooks/useDateFormat';
import LabelValueItem from './LabelValueItem';
import EditIcon from '@mui/icons-material/Edit';

interface IProps {
  lead: Lead;
  onEditPress: () => void;
}
const LeadDetailsAppointmentInfoBox = ({ lead, onEditPress }: IProps) => {
  const { formatDate } = useDateFormat();

  const leadProperties = lead.properties;
  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        bgcolor: 'white',
        m: 2,
        p: 2,
        minWidth: '300px',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap-reverse',
            gap: 2,
            borderBottom: (th) => `1px solid ${th.palette.divider}`,
            width: '100%',
            pb: 1,
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
          >
            <Typography
              fontWeight="bold"
              textTransform="uppercase"
              sx={{ color: (th) => th.palette.secondary.dark }}
            >
              APPUNTAMENTO
            </Typography>
            {(leadProperties.dealstage === DEAL_STAGE.CONTATTARE_CLIENTE ||
              leadProperties.dealstage ===
                DEAL_STAGE.APPUNTAMENTO_DA_CONFERMARE ||
              leadProperties.dealstage === DEAL_STAGE.APPUNTAMENTO_CONFERMATO ||
              leadProperties.dealstage ===
                DEAL_STAGE.APPUNTAMENTO_DA_RIFISSARE ||
              leadProperties.dealstage ===
                DEAL_STAGE.APPUNTAMENTO_ANNULLATO_STB_15GG) && (
              <IconButton onClick={onEditPress} className="no-print">
                <EditIcon sx={{ color: (th) => th.palette.secondary.dark }} />
              </IconButton>
            )}
          </Box>
        </Box>

        <Box pt={1}>
          {leadProperties?.appointment_date && (
            <LabelValueItem
              containerSx={{ pt: 2 }}
              label="Data"
              value={formatDate(leadProperties?.appointment_date, 'dd/MM/yyyy')}
            />
          )}
          {leadProperties?.appointment_hour && (
            <LabelValueItem
              containerSx={{ pt: 2 }}
              label="Ora"
              value={leadProperties?.appointment_hour}
            />
          )}
          {leadProperties?.appointment_location && (
            <LabelValueItem
              containerSx={{ pt: 2 }}
              label="Luogo"
              value={leadProperties?.appointment_location}
            />
          )}
          {leadProperties?.data_atto_concluso && (
            <LabelValueItem
              containerSx={{ pt: 2 }}
              label="Data atto"
              value={formatDate(
                leadProperties?.data_atto_concluso,
                'dd/MM/yyyy'
              )}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default LeadDetailsAppointmentInfoBox;
